import React, { FC, Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChronologicalTypes, ShipmentTrackingEvent } from '../../@posturinn/client-react';
import { formatDate } from '../../helpers/date/dateHelpers';
import * as StyledChronologicalOrderedEvents from './chronologicalOrderedEvents.styles';
import { GetMoreButton } from './chronologicalOrderedEvents.styles';

interface Props {
	delivered: boolean;
	events: ShipmentTrackingEvent[];
}

const ChronologicalOrderedEvents: FC<Props> = ({ events, delivered }) => {
	const { t } = useTranslation('myShipments');
	
	const eventsStep: number = 3; // Used to set number of initially shown events and also to increment when "show more" is clicked
	
	const [eventsLength, setEventsLength] = useState<number>(events.length); // initialize events length to
	const [shownEventsCount, setShownEventsCount] = useState<number>(eventsStep);
	useEffect(() => {
		// Sets eventsLength to a point where a maximum of eventsStep-1 future events are shown, ensuring that the current event is always in the first 3 shown events
		const numFutures = events.filter(event => event.chronologicalType === ChronologicalTypes.Future).length;
		const futuresBuffer = numFutures > eventsStep ? eventsStep-1 : numFutures;
		const newLength = events.length - numFutures + futuresBuffer;
		setEventsLength(newLength);
	}, [events]);
	
	
	const showMore = () => {
		if (shownEventsCount < eventsLength){
			setShownEventsCount(Math.min(eventsLength, shownEventsCount+eventsStep));
		}
	}
	return (
		<>
			<StyledChronologicalOrderedEvents.EventItem>
				<>
					<>
						<StyledChronologicalOrderedEvents.FillerL />
						{shownEventsCount < eventsLength
							? <GetMoreButton onClick={showMore}>{t('showMore')}</GetMoreButton>
							: <GetMoreButton onClick={() => setShownEventsCount(eventsStep)}>{t('seeLess')}</GetMoreButton>}
							
						<div></div>
					</>
					<>
						<StyledChronologicalOrderedEvents.FillerL />
						<StyledChronologicalOrderedEvents.LineWrapper>
							<StyledChronologicalOrderedEvents.Line />
						</StyledChronologicalOrderedEvents.LineWrapper>
						<div></div>
					</>
				</>
				{events.slice((eventsLength-shownEventsCount), eventsLength).map((event, i) => {
				const timestamp = typeof event.timestamp === 'string' ? event.timestamp.replace(/(?:Z|[+-]\d{2}:?\d{2})$/, '') : event.timestamp;
				const date = formatDate(timestamp, 'dd.MM.yyyy');
				const time = formatDate(timestamp, 'HH:mm');
				return (
					<Fragment key={i}>
						{i === 0 || (
							<>
								<StyledChronologicalOrderedEvents.FillerL />
								<StyledChronologicalOrderedEvents.LineWrapper>
									<StyledChronologicalOrderedEvents.Line />
								</StyledChronologicalOrderedEvents.LineWrapper>
								<div></div>
							</>
						)}
						<StyledChronologicalOrderedEvents.EventDateWrapper>
							{event.chronologicalType !== ChronologicalTypes.Future ? (
								<>
									<StyledChronologicalOrderedEvents.EventDate
										historic={
											event.chronologicalType === ChronologicalTypes.Historic
										}>
										{`${date}`}
									</StyledChronologicalOrderedEvents.EventDate>
									<StyledChronologicalOrderedEvents.EventTime>{`${time}`}</StyledChronologicalOrderedEvents.EventTime>
								</>
							) : null}
						</StyledChronologicalOrderedEvents.EventDateWrapper>
						<StyledChronologicalOrderedEvents.Dot
							current={event.chronologicalType === ChronologicalTypes.Current}
							historic={event.chronologicalType === ChronologicalTypes.Historic}
							future={event.chronologicalType === ChronologicalTypes.Future}
							delivered={delivered}>
							{event.chronologicalType === ChronologicalTypes.Historic ? '✓' : ''}
						</StyledChronologicalOrderedEvents.Dot>
						<StyledChronologicalOrderedEvents.EventsWrapper>
							<StyledChronologicalOrderedEvents.EventLocation
								historic={event.chronologicalType === ChronologicalTypes.Historic}>
								{event.title}
							</StyledChronologicalOrderedEvents.EventLocation>
							<StyledChronologicalOrderedEvents.EventDescription>
								{event.location.name}
							</StyledChronologicalOrderedEvents.EventDescription>
							{event.chronologicalType !== ChronologicalTypes.Future ? (
								<StyledChronologicalOrderedEvents.MobileEventDate
									small
									historic={event.chronologicalType === ChronologicalTypes.Historic}>
									{`${date} `}
									<span>{time}</span>
								</StyledChronologicalOrderedEvents.MobileEventDate>
							) : null}
						</StyledChronologicalOrderedEvents.EventsWrapper>
					</Fragment>
				);
			})}
			</StyledChronologicalOrderedEvents.EventItem>
		</>
	);
};

export default ChronologicalOrderedEvents;
